import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { UNIT_META } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function UnitSelect({ value, onChange, testid }) {
  const { user } = useAuth();
  const options = user?.role === "admin"
    ? Object.keys(UNIT_META)
    : (user?.assigned_units || []);
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="rounded-none bg-zinc-950 border-zinc-800">
        <SelectValue placeholder="Select Unit" />
      </SelectTrigger>
      <SelectContent className="rounded-none bg-zinc-950 border-zinc-800">
        {options.map((k) => (
          <SelectItem key={k} value={k}>
            {UNIT_META[k]?.name || k}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function ProductSelect({ unit, value, onChange, testid }) {
  const products = UNIT_META[unit]?.products || [];
  return (
    <Select value={value} onValueChange={onChange} disabled={!unit}>
      <SelectTrigger data-testid={testid} className="rounded-none bg-zinc-950 border-zinc-800">
        <SelectValue placeholder={unit ? "Select Product" : "Pick unit first"} />
      </SelectTrigger>
      <SelectContent className="rounded-none bg-zinc-950 border-zinc-800">
        {products.map((p) => (
          <SelectItem key={p} value={p}>{p}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function Field({ label, children }) {
  return (
    <div className="grid gap-1.5">
      <Label className="label-caps">{label}</Label>
      {children}
    </div>
  );
}

export function DialogShell({ open, onOpenChange, title, trigger, children, onSubmit, submitLabel = "Save", testidSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent className="rounded-none bg-[#0e0e11] border-zinc-800 max-w-2xl">
        <DialogHeader>
          <DialogTitle className="font-display font-black tracking-tight">{title}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-2">{children}</div>
        <DialogFooter>
          <Button
            data-testid={testidSubmit}
            onClick={onSubmit}
            className="bg-amber-400 hover:bg-amber-300 text-black rounded-none"
          >
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { Input, Textarea, Button };
